import React, { useState } from 'react';
import Slider from 'rc-slider';
import groupBy from 'lodash/groupBy';
import debounce from 'lodash/debounce';
import ThemedSelect from '../../misc/ThemedSelect';
import { collectOptionByType } from './utils';
function pickTextOptions(defaultOption, modelByStatus) {
    var optgroups = [];
    optgroups.push({
        label: 'Defaults',
        options: [
            {
                value: defaultOption,
                label: 'Default label'
            }
        ]
    });
    var ownOptions = collectOptionByType(modelByStatus.own, 'key');
    if (ownOptions.length > 0) {
        optgroups.push({
            label: 'Attributes',
            options: ownOptions
        });
    }
    return optgroups;
}
var SLIDER_MARKS = {
// '0.25': 'default'
};
function DebouncedSlider(_a) {
    var defaultValue = _a.defaultValue, onChange = _a.onChange;
    var _b = useState(defaultValue), value = _b[0], setValue = _b[1];
    var onSliderChange = function (newValue) {
        setValue(newValue);
        onChange(newValue);
    };
    return (React.createElement(Slider, { min: 1, max: 10, step: 1, defaultValue: defaultValue, value: value, onChange: onSliderChange, marks: SLIDER_MARKS }));
}
export default function LabelVariables(_a) {
    var model = _a.model, variables = _a.variables, defaultNodeLabel = _a.defaultNodeLabel, actions = _a.actions;
    var modelByStatus = groupBy(model, 'kind');
    var textOptions = pickTextOptions(defaultNodeLabel, modelByStatus);
    return (React.createElement("div", { className: "variables-block" },
        React.createElement("h6", { className: "title is-6 block-title" }, "Labels"),
        React.createElement("div", { className: "columns" },
            React.createElement("div", { className: "column is-4" }, "text"),
            React.createElement("div", { className: "column is-8" },
                React.createElement(ThemedSelect, { options: textOptions, value: variables.text, isDisabled: textOptions.length < 2, onChange: function (option) { return actions.setNodeLabel(option.value); } }))),
        React.createElement("div", { className: "columns" },
            React.createElement("div", { className: "column is-4" }, "density"),
            React.createElement("div", { className: "column is-8", style: { display: 'none' } },
                React.createElement(DebouncedSlider, { defaultValue: variables.density, onChange: debounce(actions.setLabelDensity, 300) })))));
}
